import React, { Component } from "react";
import Loader from "shared/components/Loader";
import * as stc from "./styles";
import { loadLibrary } from "./placesActions"

class GooglePlacesInput extends Component {
  state = {
    value: "",
    loadingLibrary: false,
    placeholder: ""
  };
  
  componentDidMount() {
    const { google } = window;
    const { placeholder, locale, currentValue, updaterFn } = this.props;
    updaterFn({ prop: 'language', value: locale });
    this.setState({
      placeholder: !placeholder ? "" : placeholder[locale],
    });

    if (currentValue && currentValue.name)
      this.setState({value: currentValue.name})

    if (!google) {
      this.setState({ loadingLibrary: true })
      loadLibrary(() => {
        this.setState({ loadingLibrary: false })
        this.setupAutocomplete()
      });
    }
    else {
      this.setupAutocomplete()
    }
  }
  
  async setupAutocomplete() {
    const { navigator } = window
    const options = {
      fields: ["place_id", "name"],
      strictBounds: false,
      types: ["establishment"],
    };
    
    try {
      if (navigator && navigator.geolocation) {
        const userLocation = await this.getCoordinates()
        options.bounds = {
          north: userLocation.lat + 0.1,
          south: userLocation.lat - 0.1,
          east: userLocation.lng + 0.1,
          west: userLocation.lng - 0.1,
        }
      }
    } finally {
      this.startAutocomplete(options)
    }
  }

  getCoordinates = () => {
    return new Promise((resolve, reject) => {
      const { navigator } = window;
      if (!navigator || !navigator.geolocation) reject(new Error("Geolocation not supported"));
        navigator.geolocation.getCurrentPosition((position) => {
          const { latitude, longitude } = position.coords;
          resolve({ lat: latitude, lng: longitude });
        },
        (e) => {
          reject(new Error(e.message));
        });
    })
  }

  startAutocomplete = options => {
    const { inputRef } = this
    const { Autocomplete } = window.google.maps.places;

    const autocomplete = new Autocomplete(inputRef, options);
    autocomplete.addListener('place_changed', () => {
      const selectedPlace = autocomplete.getPlace()
      this.handleUpdate(selectedPlace)
    })
  }

  handleUpdate = (place) => {
    const { updaterFn, name, locale } = this.props;
    const { place_id: placeId, name: placeName } = place
    this.setState({ value: placeName }) 
    if (updaterFn && typeof updaterFn === "function") {
      updaterFn({ prop: name, value: {id: placeId, name: placeName} });
      updaterFn({ prop: 'language', value: locale });
    }
  };
    
  translationTable = () => {
    const { locale } = this.props;
  
    const translationTable = {
      "pt-BR": {
        helpText: "Procure o perfil da empresa pelo nome.",
        knowMore: " Saiba mais.",
        link: "https://alboompro.com",
      },
      "pt-PT": {
        helpText: "Procure o perfil da empresa pelo nome.",
        knowMore: " Saiba mais.",
        link: "https://alboompro.com",
      },
      "en": {
        helpText: "Search your business profile by name.",
        knowMore: " Know more.",
        link: "https://alboompro.com",
      },
      "es": {
        helpText: "Procure el perfil de la empresa con el nombre.",
        knowMore: " Saber más.",
        link: "https://alboompro.com",
      }
    }
  
    return translationTable[locale]
  }

  render() {
    const { label, name, locale, tooltip, icon } = this.props;
    const { value, loadingLibrary, placeholder } = this.state;
    
    const translations = this.translationTable()

    return (
      <stc.Wrapper>
        <stc.Label>
          {label[locale]}
        </stc.Label>
        <stc.InputWrapper>
          { icon && 
            <stc.Icon src={icon} alt="search_icon" />
          }
          <stc.PlaceInput 
            name={name} 
            locale={locale} 
            icon={loadingLibrary ? <Loader /> : icon} 
            onChange={e => this.setState({ value: e.target.value })} 
            value={value}
            placeholder={placeholder}
            disabled={loadingLibrary}
            ref={inputRef => {
              if (!this.inputRef){
                this.inputRef = inputRef
              }
            }}
            style={{ paddingLeft: icon && "34px" }}
          />
        </stc.InputWrapper>
        <stc.HelpText>
          {translations.helpText}
        </stc.HelpText>
      </stc.Wrapper>
    );
  }
}

export default GooglePlacesInput;
